import More from './more'

More.install = vue => {
  vue.component(More.name, More)
}

export default More
